import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert, Spinner } from '@printdeal/ui-library';

import useMandate from '../../../../../hooks/useMandate';
import OrderDetailContext, { OrderDetailContextAfterLoad } from '../../contexts/OrderDetailContext';

import canPayOrderHelper from '../../shared/Actions/PayOrder/CanPayOrderHelper';

interface MandateInfoProps {
  orderId: string;
  mandateId: string;
}

const MandateInfo = ({
  orderId,
  mandateId,
}: MandateInfoProps) => {
  const { order } = useContext(OrderDetailContext) as OrderDetailContextAfterLoad;
  const mandateResult = useMandate(orderId, mandateId);

  if (!mandateResult) {
    return null;
  }

  if (mandateResult.status === 'pending') {
    return (<div className="pd-mt-2"><Spinner size="sm" /></div>);
  }

  if (mandateResult.status === 'error' || !mandateResult.data) {
    const isOrderPayable = canPayOrderHelper(order);

    if (isOrderPayable.enabled) {
      return (
        <Alert variant="error" className="pd-mt-2">
          <FormattedMessage
            id="account.order.payment.mandateExpired"
            defaultMessage="No active mandate could be found. Please select another payment method."
          />
        </Alert>
      );
    }

    return null;
  }

  return (
    <div>{`${mandateResult.data.signerName} - ${mandateResult.data.iban}`}</div>
  );
};

export default MandateInfo;
